import styled from 'styled-components'

import ListItem from '../ListItem'

const MenuItem = styled(ListItem)`
  align-items: center;
  font-size: 0.9em;

  svg[aria-label='FairHousing'] {
    height: 13.8px;
    width: 16px;
  }
`

export default MenuItem
